import React from 'react';
import { ResponsiveBar } from '@nivo/bar';
import { AxisProps } from '@nivo/axes';
import { NivoPieData } from './NivoPie';

const NivoBar = ({
  data,
  cardPixelWidth,
  labelTextColor,
}: {
  data: Array<NivoPieData>; //Uses Pie Chart data for the moment - We could potentially change this in future as the chart is capable of more advanced configuration.
  cardPixelWidth: number; //Used to improve rotation calculation for bottom axis.
  labelTextColor?: string | null;
}) => {
  const maxItems = cardPixelWidth / 25; //Rough estimate of how many labels can appropriately fit on the x axis.
  const tickRotation = data.length <= 10 ? 0 : data.length * (90 / maxItems);
  const includeBottomAxis: boolean = data.length < maxItems;

  const axisBottom: AxisProps | null = includeBottomAxis
    ? {
        tickSize: 5,
        tickPadding: 5,
        tickRotation: tickRotation,
        // legend: 'id', //TODO - Get axis from data?
        legendPosition: 'middle',
        legendOffset: 32,
      }
    : null;

  return (
    <ResponsiveBar
      data={data}
      keys={['value']}
      indexBy="id"
      margin={{ top: 12, right: 12, bottom: includeBottomAxis ? 40 + tickRotation / 2 : 12, left: 60 }}
      padding={0.3}
      valueScale={{ type: 'linear' }}
      indexScale={{ type: 'band', round: true }}
      colors={(d) => {
        return d.data.color as string;
      }}
      borderColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
      axisTop={null}
      axisRight={null}
      axisBottom={axisBottom}
      axisLeft={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        // legend: 'value', //TODO - Get axis from data?
        legendPosition: 'middle',
        legendOffset: -40,
      }}
      labelSkipWidth={25}
      labelSkipHeight={200}
      labelTextColor={labelTextColor || { from: 'color', modifiers: [['darker', 1.6]] }}
    />
  );
};

export default NivoBar;
